import React, { useEffect } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { useCurrentOrganization } from "../hooks/useCurrentOrganization"
import { rootPath } from "../novus-paths"

export const RequireUserNotVerified = () => {
  const navigate = useNavigate()
  const { loading, membership } = useCurrentOrganization()

  useEffect(() => {
    if (!membership?.verified) return

    navigate(rootPath({}))
  }, [membership, navigate])

  if (loading) {
    return null
  }

  return <Outlet />
}
